import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function SuperAdminRoute() {
    const { checkRole, userDetails } = useContext(AuthContext);

    if (!userDetails) return null;
    return checkRole(["SuperAdmin"]) ? <Outlet /> : <Navigate to="/admin" replace />;
}
